import { render } from "./CTA.vue?vue&type=template&id=e5c9497e&scoped=true"
import script from "./CTA.vue?vue&type=script&lang=js"
export * from "./CTA.vue?vue&type=script&lang=js"

import "./CTA.vue?vue&type=style&index=0&id=e5c9497e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5c9497e"]])

export default __exports__